var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacebookCircle = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13c0-6.077-4.923-11-11-11S2 6.923 2 13c0 5.49 4.023 10.041 9.281 10.867V16.18H8.487V13h2.794v-2.424c0-2.756 1.641-4.279 4.155-4.279 1.204 0 2.463.215 2.463.215v2.705H16.51c-1.366 0-1.792.848-1.792 1.718V13h3.05l-.487 3.18h-2.563v7.687C19.977 23.04 24 18.49 24 13z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-circle.4836c3ec.svg";
export { ForwardRef as ReactComponent };